export interface MangaItem {
  id: string;
  title: string;
  author: string;
  genre: string;
  tags: string[];
  rating: number;
  chapters: number;
  fans: string;
  description: string;
  cover: string;
  status: '连载中' | '已完结';
  badge?: string;
}

export interface GenreItem {
  name: string;
  icon: string;
  desc: string;
  count: string;
}

export const genres: GenreItem[] = [
  { name: '热血冒险', icon: 'ri-flashlight-fill', desc: '少年燃系王道，逆袭与热血并存', count: '32部甄选' },
  { name: '奇幻异世界', icon: 'ri-sparkling-2-fill', desc: '穿越转生、异界冒险与羁绊', count: '28部甄选' },
  { name: '治愈日常', icon: 'ri-cup-fill', desc: '温柔日常，暖到心里的慢生活', count: '21部甄选' },
  { name: '悬疑推理', icon: 'ri-focus-3-fill', desc: '烧脑谜题与人性博弈', count: '18部甄选' },
  { name: '科幻末世', icon: 'ri-rocket-2-fill', desc: '废土与星空下的生存史诗', count: '16部甄选' },
  { name: '青春恋爱', icon: 'ri-heart-3-fill', desc: '酸酸甜甜的青春悸动', count: '24部甄选' },
  { name: '运动竞技', icon: 'ri-basketball-fill', desc: '汗水与梦想交织的赛场', count: '14部甄选' },
  { name: '校园成长', icon: 'ri-graduation-cap-fill', desc: '关于梦想、友情与选择', count: '19部甄选' },
];

export const mangaList: MangaItem[] = [
  {
    id: 'xinghuo-changge',
    title: '星火长歌',
    author: '林晚照',
    genre: '热血冒险',
    tags: ['王道冒险', '成长', '羁绊'],
    rating: 9.6,
    chapters: 128,
    fans: '128万',
    description: '少年身负最后一缕星火，踏上一段跨越山海、点燃信念的冒险之旅。当整个世界陷入长夜，唯有不肯熄灭的心，才能点亮前路。',
    cover: 'https://readdy.ai/api/search-image?query=semi-stylized%20anime%20manga%20cover%20illustration%20of%20a%20determined%20young%20warrior%20holding%20a%20glowing%20ember%20in%20his%20hand%20under%20a%20starry%20night%20sky%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20clean%20simple%20background%2C%20dynamic%20composition%2C%20high%20detail%20digital%20painting%2C%20cinematic%20lighting&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    status: '连载中',
    badge: '本周热门',
  },
  {
    id: 'wudu-zhentanbu',
    title: '雾都侦探簿',
    author: '顾青衫',
    genre: '悬疑推理',
    tags: ['本格推理', '都市', '反转'],
    rating: 9.3,
    chapters: 96,
    fans: '86万',
    description: '常年被大雾笼罩的都市里，一个游走在灰色地带的侦探，凭借惊人的观察力破解一桩桩离奇案件。每一页都藏着下一个反转。',
    cover: 'https://readdy.ai/api/search-image?query=semi-stylized%20anime%20manga%20cover%20illustration%20of%20a%20mysterious%20detective%20in%20a%20long%20coat%20holding%20a%20magnifying%20glass%20in%20a%20foggy%20noir%20city%20alley%2C%20warm%20amber%20and%20cream%20palette%2C%20clean%20moody%20background%2C%20high%20detail%20digital%20painting%2C%20dramatic%20lighting&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    status: '连载中',
  },
  {
    id: 'yijie-canting',
    title: '异界食堂开张中',
    author: '苏黎',
    genre: '奇幻异世界',
    tags: ['美食', '异世界', '治愈'],
    rating: 9.4,
    chapters: 74,
    fans: '102万',
    description: '一座开在异界边界的小小食堂，用一碗热汤温暖了无数冒险者、精灵与流浪剑客的心。食客的眼泪与笑容，都化成了店里的烟火气。',
    cover: 'https://readdy.ai/api/search-image?query=semi-stylized%20anime%20manga%20cover%20illustration%20of%20a%20cozy%20fantasy%20restaurant%20with%20steaming%20bowls%20of%20soup%20and%20warm%20lantern%20light%2C%20cute%20chef%20character%20serving%20food%2C%20warm%20cream%20and%20coral%20palette%2C%20clean%20magical%20background%2C%20high%20detail%20digital%20painting%2C%20wholesome%20atmosphere&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    status: '连载中',
    badge: '漫友力荐',
  },
  {
    id: 'luorijiayuan',
    title: '落日机甲纪元',
    author: '墨白',
    genre: '科幻末世',
    tags: ['机甲', '末世', '硬核'],
    rating: 9.1,
    chapters: 88,
    fans: '63万',
    description: '文明崩坏后的人类蜷缩在废土城市里，驾驶残破机甲的少年军团，为守护最后一点希望向天空发起冲锋。机械与泪水的末世物语。',
    cover: 'https://readdy.ai/api/search-image?query=semi-stylized%20anime%20manga%20cover%20illustration%20of%20a%20mighty%20mecha%20giant%20standing%20against%20a%20sunset%20over%20a%20post-apocalyptic%20ruined%20city%2C%20warm%20coral%20sunset%20and%20cream%20palette%2C%20clean%20sci-fi%20background%2C%20epic%20composition%2C%20high%20detail%20digital%20painting&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    status: '连载中',
  },
  {
    id: 'yuanqiqiuchang',
    title: '元气球场！',
    author: '陈大飞',
    genre: '运动竞技',
    tags: ['篮球', '热血', '团队'],
    rating: 9.2,
    chapters: 152,
    fans: '71万',
    description: '一支濒临解散的高中篮球队，在一次次跌倒与爬起来之间，重新找回了对胜利的渴望。汗水洒落的每一个瞬间，都值得被记住。',
    cover: 'https://readdy.ai/api/search-image?query=semi-stylized%20anime%20manga%20cover%20illustration%20of%20a%20confident%20young%20basketball%20player%20dribbling%20under%20bright%20court%20lights%20with%20teammates%20in%20the%20background%2C%20warm%20cream%20and%20coral%20palette%2C%20clean%20sporty%20background%2C%20energetic%20composition%2C%20high%20detail%20digital%20painting&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    status: '连载中',
  },
  {
    id: 'xiari-huixin',
    title: '夏日回信',
    author: '江月',
    genre: '青春恋爱',
    tags: ['恋爱', '青春', '治愈'],
    rating: 9.0,
    chapters: 62,
    fans: '54万',
    description: '少年在图书馆捡到一封没有署名的信，从此与写信的女孩开始了漫长的笔友时光。夏天很长，长到足够把喜欢说出口。',
    cover: 'https://readdy.ai/api/search-image?query=semi-stylized%20anime%20manga%20cover%20illustration%20of%20a%20boy%20and%20girl%20reading%20letters%20together%20in%20a%20sunlit%20summer%20library%2C%20warm%20cream%20and%20soft%20coral%20palette%2C%20clean%20gentle%20background%2C%20romantic%20composition%2C%20high%20detail%20digital%20painting%2C%20dreamy%20light&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    status: '连载中',
    badge: '新人气王',
  },
  {
    id: 'zhijian-shaonian',
    title: '纸间少年志',
    author: '周予安',
    genre: '校园成长',
    tags: ['校园', '梦想', '青春'],
    rating: 8.9,
    chapters: 81,
    fans: '45万',
    description: '一个被埋没绘画天赋的少年，在社团与朋友的支持下，重新握起画笔。成长的路上，重要的不是抵达终点，而是路上遇见的每一个人。',
    cover: 'https://readdy.ai/api/search-image?query=semi-stylized%20anime%20manga%20cover%20illustration%20of%20a%20young%20boy%20holding%20a%20sketchbook%20and%20paintbrush%20in%20a%20sunny%20school%20campus%20with%20art%20club%20posters%2C%20warm%20cream%20and%20coral%20palette%2C%20clean%20youthful%20background%2C%20hopeful%20composition%2C%20high%20detail%20digital%20painting&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    status: '连载中',
  },
  {
    id: 'chaoxi-shoulie',
    title: '潮汐狩猎者',
    author: '沈青梧',
    genre: '奇幻异世界',
    tags: ['海洋', '冒险', '战斗'],
    rating: 9.2,
    chapters: 67,
    fans: '58万',
    description: '在被无尽潮汐吞没的世界里，一群以猎杀潮中巨兽为生的狩猎者，为了村落的存续一次次驶向深渊。海风吹过的誓言，从不食言。',
    cover: 'https://readdy.ai/api/search-image?query=semi-stylized%20anime%20manga%20cover%20illustration%20of%20a%20fierce%20sea%20hunter%20with%20a%20spear%20facing%20a%20giant%20ocean%20monster%20in%20towering%20waves%2C%20warm%20teal%20and%20cream%20palette%2C%20clean%20oceanic%20background%2C%20epic%20dynamic%20composition%2C%20high%20detail%20digital%20painting&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    status: '连载中',
  },
  {
    id: 'jingye-shitang',
    title: '静夜食堂',
    author: '李知意',
    genre: '治愈日常',
    tags: ['美食', '治愈', '温情'],
    rating: 9.5,
    chapters: 143,
    fans: '97万',
    description: '只在深夜营业的小食堂，接待着一个个带着故事的食客。一碗热汤、一句寒暄，就能让疲惫的心重新亮起来。成年人的治愈系漫画。',
    cover: 'https://readdy.ai/api/search-image?query=semi-stylized%20anime%20manga%20cover%20illustration%20of%20a%20warm%20nighttime%20diner%20counter%20with%20steaming%20comfort%20food%20and%20soft%20warm%20lights%2C%20solitary%20customer%20enjoying%20a%20meal%2C%20warm%20cream%20and%20amber%20palette%2C%20clean%20cozy%20background%2C%20gentle%20composition%2C%20high%20detail%20digital%20painting&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    status: '已完结',
    badge: '经典佳作',
  },
  {
    id: 'niguang-lianmeng',
    title: '逆光联盟',
    author: '许清野',
    genre: '热血冒险',
    tags: ['群像', '羁绊', '王道'],
    rating: 9.3,
    chapters: 110,
    fans: '76万',
    description: '一群被命运推向对立面的少年，却选择并肩站在一起。在逆光中前行的他们，用行动证明：真正的强大，是为彼此而战。',
    cover: 'https://readdy.ai/api/search-image?query=semi-stylized%20anime%20manga%20cover%20illustration%20of%20a%20group%20of%20young%20heroes%20standing%20together%20facing%20the%20sun%20with%20their%20silhouettes%20in%20bold%20coral%20light%2C%20warm%20cream%20and%20coral%20palette%2C%20clean%20dramatic%20background%2C%20inspiring%20composition%2C%20high%20detail%20digital%20painting&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    status: '连载中',
  },
];

export const testimonials = [
  {
    name: '追漫小能手',
    tag: '追更 3 年',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20smiling%20young%20woman%20avatar%20portrait%2C%20warm%20soft%20lighting%2C%20clean%20cream%20background%2C%20anime%20style%20illustration&width=200&height=200&seq=avatar-01&orientation=squarish',
    text: '在178漫画网吃了好多安利，几乎没有踩雷！特别是《异界食堂开张中》，我直接一口气追平，编辑部真的很懂我们想要什么。',
  },
  {
    name: '老二次元阿青',
    tag: '漫画收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20smiling%20young%20man%20avatar%20portrait%2C%20warm%20soft%20lighting%2C%20clean%20cream%20background%2C%20anime%20style%20illustration&width=200&height=200&seq=avatar-02&orientation=squarish',
    text: '这里的榜单比我自己刷一天还高效，推荐的《雾都侦探簿》反转设计绝了。已经习惯每周来翻一次本期清单，成了我的固定节目。',
  },
  {
    name: '拾光',
    tag: '书单分享博主',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20young%20woman%20with%20glasses%20avatar%20portrait%2C%20warm%20soft%20lighting%2C%20clean%20cream%20background%2C%20anime%20style%20illustration&width=200&height=200&seq=avatar-03&orientation=squarish',
    text: '分类做得特别清晰，想找什么类型的漫画直接进对应分区就行。编辑部还会标注推荐理由，这种认真劲儿很圈粉。',
  },
  {
    name: '夜航船',
    tag: '安利投稿人',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20smiling%20teenage%20boy%20avatar%20portrait%2C%20warm%20soft%20lighting%2C%20clean%20cream%20background%2C%20anime%20style%20illustration&width=200&height=200&seq=avatar-04&orientation=squarish',
    text: '第一次试着在178漫画网投稿安利自己喜欢的冷门作品，真的被编辑部认真收录推荐了，这种感觉太有成就感了！',
  },
];

export const faqItems = [
  {
    q: '178漫画网推荐的作品都是真实的吗？',
    a: '是的。178漫画网推荐清单里的每一部作品，都由编辑部逐部试读、并结合漫友真实投稿与评价后甄选收录。我们坚持只推荐真正值得看的作品，不收录与主题无关或注水的清单。',
  },
  {
    q: '我喜欢的漫画被删除了怎么办？',
    a: '如果某部作品因版权或其他原因需要下架，我们会从公开清单中移除，但不会影响你的追更记录。你仍可通过搜索继续浏览其他优质安利推荐。',
  },
  {
    q: '如何向178漫画网投稿安利一部作品？',
    a: '欢迎通过首页底部的"投稿安利"表单填写作品名称、分类、作者和推荐理由，编辑部会尽快审核。一旦收录，你的安利会出现在对应的好漫推荐清单中。',
  },
  {
    q: '网站会收费吗？',
    a: '不会。178漫画网是一个免费的安利推荐内容平台，浏览推荐清单、查看评价均无需付费。我们不做任何形式的付费推广，只凭作品质量说话。',
  },
  {
    q: '多久更新一次推荐清单？',
    a: '编辑部每周更新"本期安利清单"，并根据热点与漫友反馈持续更新热门佳作和分类榜单。你可以随时回来发现新鲜的好漫。',
  },
];